import React from 'react';
import { Badge, Menu } from 'antd';

const MenuDesktop = ({ viewModel }) => {
  const { menuItems, menuClick } = viewModel;

  const items = menuItems.map((item) => {
    if (!item.badgeCount) {
      return item;
    }
    return {
      ...item,
      icon: (
        <Badge count={item.badgeCount > 99 ? '99+' : item.badgeCount} size='small' color='#1677ff' offset={[2, -2]}>
          {item.icon}
        </Badge>
      ),
    };
  });

  return (
    <Menu
      theme="dark"
      mode="inline"
      onClick={menuClick}
      defaultSelectedKeys={['']}
      items={items}
    />
  );
};

export default MenuDesktop;
